/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.membership.offering',
  'acme.common.service.userPreferences',
  'acme.common.service.tenant',
  'acme.common.factory.notice',
  'acme.view.application.membership.offerings.modals.remove.controllers',
  'acme.view.application.membership.offerings.create.details.controllers',
  'acme.view.application.membership.offerings.create.policies.controllers',
  'acme.view.application.membership.offerings.create.lifecycle.controllers'
])

.controller('MembershipOfferingsCreateController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'NoticeFactory', 'MembershipOfferingService', 'HelpersService', 'UserPreferencesService', 'TenantService', 'TenantData', function($scope, $state, $uibModal, $timeout, ApiService, NoticeFactory, MembershipOfferingService, HelpersService, UserPreferencesService, TenantService, TenantData) {

    $scope.membershipOfferingsCreate = {

      model: {},
      priceLists: [],
      lifecycleRules: [],
      removeModal: {},


      tab: 'details',
      mode: 'create',

      notice: new NoticeFactory(),

      dateFormat: UserPreferencesService.getDateFormat(),
      saveReady: MembershipOfferingService.ready,
      loadedReady: MembershipOfferingService.loaded,

      isSaving: false,
      isLoaded: false,
      isSubmitted: false,
      saveAndClose: false,

      tabErrors: {
        details: false,
        policies: false,
        lifecycle: false
      },

      init: function() {

        if ($state.params) {

          if ($state.params.offeringId) {
            this.mode = 'edit';
            this.getOffering();
          } else {
            this.getLifecycleRules();
          }

        }

        if (TenantData.data && TenantData.data.payload) {
          TenantService.setModel(TenantData.data.payload.list[0]);
        }

        $scope.$emit('Application::contentTitleChange', {
          title: HelpersService.cap(this.mode) + ' Membership Offering',
          buttonRight: {
            permissions: 'MEMBERSHIP_CATEGORY_CREATE',
            label: (this.isMode('edit')) ? 'Save' : 'Create & Continue',
            action: function() {
              $scope.membershipOfferingsCreate.complete();
            }
          },
          buttonLeft: {
            label: '< Back',
            action: function() {
              $scope.membershipOfferingsCreate.cancel();
            }
          }
        });

        MembershipOfferingService.unLoaded();

        $scope.$on('$destroy', $scope.$watchCollection('membershipOfferingsCreate.saveReady', this.onSaveReady));
        $scope.$on('$destroy', $scope.$watchCollection('membershipOfferingsCreate.loadedReady', this.onLoadReady));
        $scope.$on('MembershipOffering::PriceListsUpdate', this.onMembershipOfferingPriceListsUpdate);
        $scope.$on('MembershipOffering::Error', this.onMembershipOfferingsError);
        $scope.$on('MembershipOffering::Success', this.onMembershipOfferingsSuccess);

      },

      getCategory: function() {
        ApiService.membership.categories.detail($state.params.categoryId).then(this.success.getCategory, this.error.getCategory);
      },

      getLifecycleRules: function() {
        ApiService.rulesEngine.lifecycle.list().then(this.success.getLifecycleRules, this.error.getLifecycleRules);
      },
      
      getOffering: function() {
        ApiService.membership.offerings.detail({
          categoryId: $state.params.categoryId,
          offeringId: $state.params.offeringId
        }).then(this.success.getOffering, this.error.getOffering);
      },

      updateModel: function() {
        $scope.$broadcast('MembershipOfferingsCreateController::Update', {
          offering: $scope.membershipOfferingsCreate.model,
          lifecycleRules: $scope.membershipOfferingsCreate.lifecycleRules
        });
      },

      hasTabErrors: function(tab) {
        return (this.tabErrors[tab]);
      },

      isValidName: function() {

        var r = true;

        if (this.isSubmitted) {
          r = (this.model.name && this.model.name.replace(/\s/g, '').length > 0);
        }

        return r;
      },

      isValidDuration: function() {

        var r = true,
            duration = parseInt(this.model.duration, 10);

        if (this.isSubmitted) {
          r = (!isNaN(duration) && duration > 0);
        }

        return r;
      },

      validate: function() {
        this.isSubmitted = true;

        return (this.isValidName());
      },

      update: function(close) {
        // Triggers update for all views the model in MembershipOfferingService
        // Flags are set in saveReady property
        // Watcher determines when everything is ready to save
        if (!this.isSaving) {
          this.saveAndClose = (close);
          this.isSaving = true;
          $scope.$broadcast('MembershipOfferingsCreateController::Save', { save: true });
        }
      },

      create: function() {
        // Triggers create for all views and updates the model in MembershipOfferingService
        // Flags are set in saveReady property
        // Watcher determines when everything is ready to save
        if (!this.isSaving) {
          $scope.$broadcast('MembershipOfferingsCreateController::Save', {create: true});
        }
      },

      save: function() {

        var offering = MembershipOfferingService.getModel();

        // Copy name from master view
        offering.name = this.model.name;

        if (this.validate()) {
          if (this.isMode('edit')) {
            ApiService.membership.offerings.update(angular.extend({
              categoryId: $state.params.categoryId,
              offeringId: offering.id
            }, offering)).then(this.success.update, this.error.update);
          } else {
            ApiService.membership.offerings.create(angular.extend({
              categoryId: $state.params.categoryId
            }, offering)).then(this.success.create, this.error.create);
          }
        }

      },

      remove: function() {
        var self = $scope.membershipOfferingsCreate;

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/offerings/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipOfferingsModalsRemoveController',
          resolve: {
            currentOffering: function() {
              return self.model;
            }
          }
        });

        self.removeModal.result.then(function () {
          if (self.hasPriceList()) {
            self.priceLists = angular.copy(MembershipOfferingService.details.priceLists);
          }
          ApiService.membership.offerings.remove({
            categoryId: $state.params.categoryId,
            offeringId: self.model.id
          }).then(self.success.remove, self.error.remove);
        }, function (message) {
          // Invoked when modal completes with dismiss(params)
        });

      },

      hasPriceList: function() {
        return (MembershipOfferingService.details.priceLists instanceof Array &&
                MembershipOfferingService.details.priceLists.length &&
                MembershipOfferingService.details.priceLists[0] &&
                MembershipOfferingService.details.priceLists[0].id);
      },

      cancel: function() {
        // Delete price list if in create mode
        if (this.isMode('create')) {
          if (this.hasPriceList()) {
            ApiService.price.lists.remove(MembershipOfferingService.details.priceLists[0].id).then(this.success.cancel, this.error.cancel);
          }
        }
        $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });
      },

      complete: function() {

        if (!this.isSaving && this.isLoaded) {
          // Reset for onSaveReady
          MembershipOfferingService.unReady();

          if (this.isMode('edit')) {
            this.update();
          } else {
            this.create();
          }
        }

      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      isTab: function(tab) {
        return (this.tab === tab);
      },

      getTab: function(tab) {
        this.tab = tab;

        // next tick
        $timeout(function() {
          $scope.$broadcast('MembershipOfferingsCreateController::FocusTab', { tab: tab });
        }, 0);
      },

      success: {
        init: function(response) {},

        create: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.isSubmitted = false;
          self.isSaving = false;
          // Reset for onSaveReady
          MembershipOfferingService.unReady();
          // Go to edit state
          $state.go('application.membership.offerings.edit', { categoryId: $state.params.categoryId, offeringId: response.data.payload.id });

          self.notice.showSuccessMessages([
            { message: 'Successfully created' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);

        },

        update: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.isSubmitted = false;
          self.isSaving = false;
          // Cleanup rules
          // Leaving commented for now this will create rules but never actually delete them
          // MembershipOfferingService.purgeRules();
          // Reset for onSaveReady
          MembershipOfferingService.unReady();

          if (self.saveAndClose) {

            self.saveAndClose = false;
            $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });

          }else{
            self.notice.showSuccessMessages([
              { message: 'Successfully updated' }
            ]);

            $timeout(function () {
              self.notice.hideSuccessMessages();
            }, 3000);
          }

        },

        remove: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.isSubmitted = false;
          $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });

          // Copied before removal
          if (self.priceLists instanceof Array &&
              self.priceLists.length &&
              self.priceLists[0] &&
              self.priceLists[0].id) {
            ApiService.price.lists.remove(self.priceLists[0].id).then(self.success.cancel, self.error.cancel);
          }

        },

        cancel: function(response) {},

        getCategory: function(response) {},

        getLifecycleRules: function (response) {
          var self = $scope.membershipOfferingsCreate;
          self.lifecycleRules = response.data.payload;
          self.updateModel();
        },

        getOffering: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.model = response.data.payload;
          self.getLifecycleRules();
        }

      },

      error: {
        init: function(response) {},
        generic: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.isSubmitted = false;
          self.saveAndClose = false;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);

        },
        create: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.error.generic(response);
          self.isSaving = false;
          self.isLoaded = true;
          // Reset for onSaveReady
          MembershipOfferingService.unReady();
        },
        update: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.error.generic(response);
          self.isSaving = false;
          self.isLoaded = true;
          // Reset for onSaveReady
          MembershipOfferingService.unReady();
        },
        remove: function(response) {
          $scope.membershipOfferingsCreate.error.generic(response);
        },
        cancel: function(response) {},
        getCategory: function(response) {
          $scope.membershipOfferingsCreate.error.generic(response);
        },
        getLifecycleRules: function (response) {
          var self = $scope.membershipOfferingsCreate;

          self.error.generic(response);
          self.isLoaded = true;
        },
        getOffering: function(response) {
          var self = $scope.membershipOfferingsCreate;

          self.error.generic(response);
          self.isLoaded = true;
        }
      },

      onSaveReady: function(n, o) {

        var self = $scope.membershipOfferingsCreate;

        if (n.details && n.lifecycle && n.policies) {

          self.notice.hideErrorMessages();
          self.notice.hideSuccessMessages();
          self.save();

        }

      },

      onLoadReady: function(n, o) {

        var self = $scope.membershipOfferingsCreate;

        if (n.details && n.lifecycle && n.policies) {
          self.isLoaded = true;
        }

      },

      onMembershipOfferingPriceListsUpdate: function(e, data) {

        var self = $scope.membershipOfferingsCreate;

        // Save tangentially don't want to include this in the model
        // because we extend it later on during save
        if (self.isMode('edit')) {
          self.update();
        }

      },

      onMembershipOfferingsSuccess: function(e, data) {
        var self = $scope.membershipOfferingsCreate;

        if (self.tabErrors.hasOwnProperty(data.tab)) {
          self.tabErrors[data.tab] = false;
        }
      },

      onMembershipOfferingsError: function(e, data) {
        var self = $scope.membershipOfferingsCreate;

        if (self.tabErrors.hasOwnProperty(data.tab)) {
          // Added for UI responsiveness
          $timeout(function() {
            self.isSaving = false;
          }, 300);
          self.tabErrors[data.tab] = true;
          self.notice.showErrorMessages([
            { message: data.message }
          ]);
        }
      }

    };

    $scope.membershipOfferingsCreate.init();

}]);